/** @jsx jsx */
import { jsx } from "@emotion/react";
import { createContext, FC, ReactNode, useContext } from "react";
import GlobalConfirmationModal from "./GlobalConfirmModal";
import useModalStack from "./useModalStack";
import useModalRegistrators, { Registrators } from "./useModalRegistrators";
import GlobalTextPromptModal from "./GlobalTextPromptModal";

type Props = {
  children: ReactNode;
};

const GlobalConfirmationContext = createContext<Registrators>({
  confirm: async () => false,
  textPrompt: async () => false,
});

const GlobalModalProvider = ({ children }: Props) => {
  const { currentDescriptor, controls } = useModalStack();
  const registrators = useModalRegistrators(controls);

  return (
    <GlobalConfirmationContext.Provider value={registrators}>
      {currentDescriptor?.type === "confirm" && (
        <GlobalConfirmationModal descriptor={currentDescriptor} />
      )}

      {currentDescriptor?.type === "textPrompt" && (
        <GlobalTextPromptModal descriptor={currentDescriptor} />
      )}

      {children}
    </GlobalConfirmationContext.Provider>
  );
};

export const useGlobalModalRegistrators = () => {
  const contextState = useContext(GlobalConfirmationContext);

  if (!contextState) {
    // Jestli Ti to tady padlo, tak to znamena, ze se snazis pouzivat kontext mimo Provider
    // https://reactjs.org/docs/context.html#api
    throw new Error("34frgiofsoiserio");
  }

  return contextState.confirm;
};

export default GlobalModalProvider;
